import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TenantDepartmentState } from "src/types/tenantDepartment.types";

const initialState: TenantDepartmentState = {
  createTenantDepartment: {
    loading: false,
    data: null,
    error: null,
  },
  editTenantDepartment: {
    loading: false,
    data: null,
    error: null,
  },
  tenantDepartmentList: {
    loading: false,
    data: null,
    error: null,
  },
  deleteTenantDepartment: {
    loading: false,
    data: null,
    error: null,
  },
};

const tenantDepartmentSlice = createSlice({
  name: "tenantDepartment",
  initialState,
  reducers: {
    // create department actions
    createTenantDepartmentRequest: (state, action: PayloadAction<any>) => {
      state.createTenantDepartment.loading = true;
      state.createTenantDepartment.data = null;
      state.createTenantDepartment.error = null;
    },
    createTenantDepartmentSuccess: (state, action: PayloadAction<any>) => {
      state.createTenantDepartment.loading = false;
      state.createTenantDepartment.data = action.payload;
      state.createTenantDepartment.error = null;
    },
    createTenantDepartmentError: (state, action: PayloadAction<string>) => {
      state.createTenantDepartment.loading = false;
      state.createTenantDepartment.data = null;
      state.createTenantDepartment.error = action.payload;
    },
    resetCreateTenantDepartment: (state) => {
      state.createTenantDepartment = { loading: false, data: null, error: null };
    },

    // edit department actions
    editTenantDepartmentRequest: (state, action: PayloadAction<any>) => {
      state.editTenantDepartment.loading = true;
      state.editTenantDepartment.data = null;
      state.editTenantDepartment.error = null;
    },
    editTenantDepartmentSuccess: (state, action: PayloadAction<any>) => {
      state.editTenantDepartment.loading = false;
      state.editTenantDepartment.data = action.payload;
      state.editTenantDepartment.error = null;
    },
    editTenantDepartmentError: (state, action: PayloadAction<string>) => {
      state.editTenantDepartment.loading = false;
      state.editTenantDepartment.data = null;
      state.editTenantDepartment.error = action.payload;
    },
    resetEditTenantDepartment: (state) => {
      state.editTenantDepartment = { loading: false, data: null, error: null };
    },

    // get department list
    getTenantDepartmentListRequest: (
      state,
      action: PayloadAction<{
        page?: number;
        limit: number;
        search?: string;
      }>
    ) => {
      state.tenantDepartmentList.loading = true;
      state.tenantDepartmentList.data = null;
      state.tenantDepartmentList.error = null;
    },
    getTenantDepartmentListSuccess: (state, action: PayloadAction<any>) => {
      state.tenantDepartmentList.loading = false;
      state.tenantDepartmentList.data = action.payload;
      state.tenantDepartmentList.error = null;
    },
    getTenantDepartmentListError: (state, action: PayloadAction<string>) => {
      state.tenantDepartmentList.loading = false;
      state.tenantDepartmentList.data = null;
      state.tenantDepartmentList.error = action.payload;
    },
    resetTenantDepartmentList: (state) => {
      state.tenantDepartmentList = { loading: false, data: null, error: null };
    },

    // delete department actions
    deleteTenantDepartmentRequest: (state, action: PayloadAction<string>) => {
      state.deleteTenantDepartment.loading = true;
      state.deleteTenantDepartment.data = null;
      state.deleteTenantDepartment.error = null;
    },
    deleteTenantDepartmentSuccess: (state, action: PayloadAction<any>) => {
      state.deleteTenantDepartment.loading = false;
      state.deleteTenantDepartment.data = action.payload;
      state.deleteTenantDepartment.error = null;
    },
    deleteTenantDepartmentError: (state, action: PayloadAction<string>) => {
      state.deleteTenantDepartment.loading = false;
      state.deleteTenantDepartment.data = null;
      state.deleteTenantDepartment.error = action.payload;
    },
    resetDeleteTenantDepartment: (state) => {
      state.deleteTenantDepartment = { loading: false, data: null, error: null };
    },
  },
});

export const {
  createTenantDepartmentRequest,
  createTenantDepartmentSuccess,
  createTenantDepartmentError,
  resetCreateTenantDepartment,

  editTenantDepartmentRequest,
  editTenantDepartmentSuccess,
  editTenantDepartmentError,
  resetEditTenantDepartment,

  getTenantDepartmentListRequest,
  getTenantDepartmentListSuccess,
  getTenantDepartmentListError,
  resetTenantDepartmentList,

  deleteTenantDepartmentRequest,
  deleteTenantDepartmentSuccess,
  deleteTenantDepartmentError,
  resetDeleteTenantDepartment,
} = tenantDepartmentSlice.actions;

export default tenantDepartmentSlice.reducer;
